<template>
  <div id="app">
    <com-loading v-if="show_loading"></com-loading> 
    <header-share desc="高能玩家聚集地" :clientType="client_type" opacity="1"></header-share>
    <template v-if="!show_loading">
      <component :is="contentCpt" :link-info="link">
        <template #title>
          <section-article-title :link-info="link" :is-concept="is_concept"></section-article-title>
        </template>
        <template #user>
          <section-author :link-info="link" :is-concept="is_concept"></section-author>
        </template>
        <!-- 文章模版 -->
        <template #content>
          <div class="article-content"> 
            <component 
              v-for="line, index in article.content"
              :key="index" 
              :is="line.cpt"
              :data-info="line.data"
              :articleInfo="article"
            />
          </div> 
        </template>
        <template #tag>
          <section-tags :link-info="link" :is-concept="is_concept" ></section-tags>
        </template>
      </component>
      <section-bottom-info :linkInfo="link" :is-concept="is_concept"></section-bottom-info>
      <section-comments :comments="comments" :linkInfo="link" :is-concept="is_concept"></section-comments>
      <!-- 悬浮按钮 -->
      <div class="app-btn" @click="openInApp">
        App 内打开
        <OutOpen :protocol="heybox_protocol" :page-identifier="'bbs/link'"  v-deeplink></OutOpen>
      </div>
    </template> 
  </div>
</template>

<script>
import { webpFormat, getUrlParam, executeProtocolOutApp} from '_lib/utils'
import { getPostSharePageData } from '_api/bbs/bbs'
import OutOpen from '_com/OutOpen'
import HeaderShare from '_com/base/ShareHeader'
import ViewNormal from './views/view-normal.vue'
import ViewPicture from './views/view-picture.vue'
import SectionBottomInfo from './sections/section-bottom-info.vue'
import SectionArticleTitle from './sections/section-article-title.vue'
import SectionAuthor from './sections/section-author.vue'
import SectionTags from './sections/section-tags.vue'
import SectionComments from './sections/section-comments.vue'
import ComLoading from './components/com-loading.vue'
import { Article } from '../post-article/platform/share/main'
import { CLIENT_TYPE, LINK_PROTOCOL } from './assets/js/global'
import { deepLinkManager } from './assets/plugin/deepLink'
export default {
  components: {
    OutOpen,
    HeaderShare,
    ViewNormal,
    ViewPicture,
    SectionBottomInfo,
    SectionComments,
    SectionArticleTitle,
    SectionAuthor,
    SectionTags,
    ComLoading,
  },
  created () {
    this.getData()
  },
  data () { 
    return {
      link_id: getUrlParam('link_id'),

      link: null,
      article: {},
      comments: [],
      is_concept: false,

      show_loading: true,
      
      shareConfig: null,
      client_type: CLIENT_TYPE,
      heybox_protocol: LINK_PROTOCOL, 

      vote_info: null, // 投票
    } 
  },
  methods: {
    async getData () {
      await webpFormat()
      const { data, status } = await getPostSharePageData({
        offset: 0,
        limit: 3,
        link_id: this.link_id,
        os_type: 'web',
        use_concept_type: getUrlParam('concept')
      })
      console.log(data);
      if (status != 200) return
      this.link = data.link // 帖子数据
      if (!this.link) return
      LINK_TAG = data.link.link_tag
      this.comments = data.comments // 评论
      this.is_concept = Boolean(this.link.use_concept_type) // 是否是图文帖
      // 初始化投票
      this.vote_info = data.vote_info
      // 初始化文章
      this.article = this.initArticle(data)
      this.handleShareInfo(data)
      this.show_loading  = false
    },
    // 在app打开帖子 
    openInApp () {
      executeProtocolOutApp({
        "protocol_type": "openLink",
        "link": {
          "linkid": this.link_id,
          "link_tag": LINK_TAG,
          "use_concept_type" : this.is_concept ? 1 : 0
        }
      })
    },  
    handleShareInfo (data) {
      if (data.share_data) {
        this.shareConfig = {
          title: data.share_data.share_title || '',
          desc: data.share_data.share_desc || '',
          link: data.share_data.share_url || window.location.href,
          imgUrl: data.share_data.share_img || '',   
        }
      }
      deepLinkManager.launchWxShare(this.shareConfig || {})
    },
    initArticle (data) {
      let article_link = this.is_concept 
        ? Object.assign({}, data.link, {content: data.link.content.filter(_=>_.type == 'text')}) 
        : data.link
      return new Article('share', article_link)
    }
  },
  computed: {
    contentCpt () {
      return this.is_concept ? 'viewPicture' : 'viewNormal'
    }
  },
}

</script>

<style lang="less">
@import '~_style/common.css';
@import "./assets/css/level.less";
html, body {
  user-select: auto;
}
#app {
  min-height: 100vh;
  width: 100%;
  max-width: 640px;
  margin: auto;
  background: #fff;
  &::after {
    content: "";
    width: 100%;
    height: 110px;
    display: block;
    background: #FFFFFF;
  }
  .article-content {
    margin-bottom: 10px;
    padding: 0 12px;
    line-height: 1.6;
    font-size: 16px;
    & > :first-child {
      margin-top: 8px;
    }
  }
}
.app-btn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 60px;
  width: 100px;
  margin: auto;
  border-radius: 17px;
  font-size: 12px;
  text-align: center;
  line-height: 34px;
  color: #FFFFFF;
  background: #14191e;
  z-index: 2020;
  box-shadow: 0 10px 16px 0 rgba(20, 25, 30 , 14%);
} 
</style>